import React, { useEffect, useState } from 'react'
import { FaFilter, FaCalendarDay, FaClipboardList, FaExclamationCircle } from 'react-icons/fa'; // Import the filter icon from react-icons
import axios from 'axios';

function ListingStats() {

    const [listingsAddedToday, setListingsAddedToday] = useState(0);
    const [expiringToday, setExpiringToday] = useState(0);
    const [listingsTotal, setListingsTotal] = useState(0);
    const fetchAnalyticsData = async () => {
        try {
          const todaListings = await axios.get(`${process.env.REACT_APP_SCRAPING_URL}/listings-today`);
          const totalTotal = await axios.get(`${process.env.REACT_APP_SCRAPING_URL}/listings-total`);
          const expiringToday = await axios.get(`${process.env.REACT_APP_SCRAPING_URL}/listings-deadline-today`)
          setListingsTotal(totalTotal.data.count);
          setListingsAddedToday(todaListings.data.count);
          setExpiringToday(expiringToday.data.count);
        } catch (error) {
          console.error('Error fetching analytics data:', error);
        }
      };
    useEffect(()=> {
        fetchAnalyticsData()
    }, [])
  return (
    <div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-5 bg-white dark:bg-gray-800 dark:text-white">
            <div className="flex-1 min-w-[300px] max-w-sm">
                <a href="#" className="block p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    <h3 className="mb-2 tracking-tight text-sm text-gray-900 dark:text-white flex items-center">
                    <FaCalendarDay className="mr-2" /> Listings Today
                    </h3>
                    <p className="font-bold text-gray-700 dark:text-gray-400">{listingsAddedToday}</p>
                    <p className='text-muted-foreground text-xs'>{listingsAddedToday * 3} minutes saved</p>
                </a>
                </div>
                <div className="flex-1 min-w-[300px] max-w-sm">
                <a href="#" className="block p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    <h3 className="mb-2 tracking-tight text-sm text-gray-900 dark:text-white flex items-center">
                    <FaClipboardList className="mr-2" /> Total Leads Scanned
                    </h3>
                    <p className="font-bold text-gray-700 dark:text-gray-400">{listingsTotal}</p>
                    <p className='text-muted-foreground text-xs'>{listingsTotal * 3} minutes saved</p>
                </a>
                </div>
                <div className="flex-1 min-w-[300px] max-w-sm">
                <a href="#" className="block p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    <h3 className="mb-2 tracking-tight text-sm text-gray-900 dark:text-white flex items-center">
                    <FaExclamationCircle className="mr-2" /> Expiring Today
                    </h3>
                    <p className="font-bold text-gray-700 dark:text-gray-400">{expiringToday}</p>
                    <p className='text-muted-foreground text-xs'>{expiringToday} expire today</p>
                </a>
            </div>
        </div>
    </div>
  )
}

export default ListingStats